import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home/Home.vue'
import TheLogin from '../views/Login/Login.vue'
import TheLoginFooter from '../components/TheLoginFooter/TheLoginFooter.vue'
import TheMainFooter from '../components/TheMainFooter/TheMainFooter.vue'
import store from '@/store';
import cookie from '@/api/cookie';
import Catalog from '@/views/Catalog/Catalog.vue';
import CatalogFull from '@/views/Catalog/CatalogFull.vue';
import CatalogSpec from '@/views/Catalog/CatalogSpec.vue';
import Categories from '@/views/Categories/Categories.vue';
import Banner from '@/components/Banner/Banner';
import TheSubNavigation from '@/components/TheSubNavigation/TheSubNavigation.vue';
import Auth from '../api/Auth';
import Product from '@/views/Product/Product';
import Basket from '@/views/Basket/Basket';
import Unsecured from '@/views/Unsecured/Unsecured';
import Breadcrumbs from '@/views/Breadcrumbs/Breadcrumbs.vue';

import Contacts from '@/views/Contacts/Contacts';

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			meta: { requiresAuth: true },
			name: 'home',
			components: {
				default: Home,
				banner: Banner,
				footer: TheMainFooter
			},
		},
		{
			path: '/login',
			name: 'login',
			// одного cookie мало: если профиль получить не удалось (нет сети, ошибка API),
			// '/' вернёт сюда же, и страницы бесконечно перенаправляли друг на друга (белый экран)
			async beforeEnter(to, from, next) {
				if (cookie.getCookie('PHPSESSID') && await Auth.check()) next('/')
				else next()
			},
			components: {
				default: TheLogin,
				footer: TheLoginFooter
			}
		},
		{
			path: '/catalog',
			meta: { requiresAuth: true },
			components: {
				default: Catalog,
				banner: Banner,
				footer: TheMainFooter
			},
			children: [
				{
					path: '',
					component: CatalogFull
				},
				{
					path: ':spec',
					component: CatalogSpec,
					props: true
				}
			]
		},
		{
			path: '/product/:id',
			meta: { requiresAuth: true },
			name: 'product',
			components: {
				default: Product,
				footer: TheMainFooter,
				subNavigation: TheSubNavigation,
				breadcrumbs: Breadcrumbs
			},
		},
		{
			path: '/basket',
			meta: { requiresAuth: true },
			components: {
				default: Basket,
				footer: TheMainFooter,
				subNavigation: TheSubNavigation
			},
			beforeEnter(to, from, next) {
				if (!store.getters.clientProfile.c1code) next('/')
				else next()
			}
		},
		{
			path: '/unsecured',
			meta: { requiresAuth: true },
			components: {
				default: Unsecured,
				footer: TheMainFooter,
				subNavigation: TheSubNavigation
			},			
			beforeEnter(to, from, next) {
				if (!store.getters.clientProfile.c1code) next('/')
				else next()
			}
		},
		{
			path: '/contacts',
			meta: { requiresAuth: true },
			name: 'Contacts',
			components: {
				default: Contacts,
				footer: TheMainFooter,
				breadcrumbs: Breadcrumbs
			},
		},
		{
			path: '/categories/:cat+',
			meta: { requiresAuth: true },
			name: 'categories',
			components: {
				default: Categories,
				footer: TheMainFooter,
				breadcrumbs: Breadcrumbs
			},
		},
		{
			path: '/my-profile',
			meta: { requiresAuth: true },
			components: {
				default: () => import(/* webpackChunkName: "my-profile" */'@/views/PrivateOffice/PrivateOffice'),
				footer: TheMainFooter,
				subNavigation: TheSubNavigation
			},
			children: [
				{
					path: '',
					component: () => import(/* webpackChunkName: "my-profile" */'@/views/PersonalInfo/PersonalInfo'),
					children: [
						{
							path: '',
							components: {
								clientInfo: () => import(/* webpackChunkName: "my-profile-client" */'@/views/ClientInfo/ClientInfo'),
								managerInfo: () => import(/* webpackChunkName: "my-profile-manager" */'@/views/ManagerInfo/ManagerInfo'),
								extra: () => import(/* webpackChunkName: "my-profile" */'@/views/RecoveryPassword/RecoveryPassword'),
							}

						}
					]
				},
				{
					path: 'feedback',
					component: () => import(/* webpackChunkName: "my-profile-client" */'@/views/Feedback/Feedback'),
				},
				{
					path: 'orders',
					component: () => import(/* webpackChunkName: "my-profile" */'@/views/Orders/Orders'),
					children: [
						{
							name: 'orderDetail',
							path: ':id',
							component: () => import(/* webpackChunkName: "my-profile" */'@/views/OrderDetail/OrderDetail'),
						}
					]
				},
				{
					path: 'clients',
					component: () => import(/* webpackChunkName: "my-profile-manager" */'@/views/Clients/Clients'),
					children: [
						{
							name: 'client',
							path: ':id',
							component: () => import(/* webpackChunkName: "my-profile-manager" */'@/views/ClientInfo/ClientInfo'),
						}
					]
				},
				{
					path: 'clients-debt',
					component: () => import(/* webpackChunkName: "clients-debt" */'@/views/ClientsDebt/ClientsDebt'),
				},
				{
					path: 'supervisor-analytics',
					component: () => import(/* webpackChunkName: "supervisor-analytics" */'@/views/SupervisorAnalytics/SupervisorAnalytics'),
				},
			]
		},
		{
			path: '/clients/:cid',
			meta: { requiresAuth: true },
			components: {
				default: () => import(/* webpackChunkName: "my-profile-manager" */'@/views/ClientsDetail/ClientsDetail'),
				footer: TheMainFooter
			},
			children: [
				{
					path: '',
					component: () => import(/* webpackChunkName: "my-profile" */'@/views/PersonalInfo/PersonalInfo'),
					children: [
						{
							path: '',
							name: 'myClient',
							components: {
								clientInfo: () => import(/* webpackChunkName: "my-profile-manager" */'@/views/ClientInfo/ClientInfo'),
							}
						}
					]
				},
				{
					path: 'orders',
					component: () => import(/* webpackChunkName: "my-profile" */'@/views/Orders/Orders'),
					children: [
						{
							path: ':id',
							name: 'clientOrderDetail',
							component: () => import(/* webpackChunkName: "my-profile" */'@/views/OrderDetail/OrderDetail'),
						}
					]
				},
			]
		}
	]
})
router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (await Auth.check()) next()
		else next({
			name: 'login'
		})
	} else {
		next()
	}
})

// После деплоя старые чанки удаляются с сервера (404), и открытая вкладка со старым index.html
// не может подгрузить lazy-роут. Перезагружаем страницу на целевой адрес, чтобы получить новую сборку.
const CHUNK_RELOAD_KEY = 'chunkReloadAt'
let pendingPath: string | null = null

router.beforeEach((to, from, next) => {
	pendingPath = to.fullPath
	next()
})

router.onError((error: Error) => {
	if (!/Loading (CSS )?chunk .+ failed/i.test(error.message)) return

	let lastReload = 0
	try {
		lastReload = +(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)
		sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
	} catch (e) { }
	// защита от бесконечной перезагрузки, если чанк действительно недоступен
	if (Date.now() - lastReload < 10000) return

	if (pendingPath) window.location.assign(pendingPath)
	else window.location.reload()
})

export default router
